<script setup>
// Content-block wrapper around `sectionCardsBlock` so markdown ContentPages can
// render the section's "Learn more…" splash cards without hard-coding the list.
// The section defaults to the route's `meta.section` (set by the content-page
// route registry) but can be overridden per-block; the current page is derived
// from the route path so the card for the page you're on is dropped.
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import LinkCardsBlock from './LinkCardsBlock.vue'
import { sectionCardsBlock } from '@/utils/sectionCards'

const props = defineProps({
  block: { type: Object, default: () => ({}) },   // { section? }
})

const route = useRoute()

const cardsBlock = computed(() =>
  sectionCardsBlock(props.block.section || route.meta.section, route.path)
)
</script>

<template>
  <LinkCardsBlock v-if="cardsBlock" :block="cardsBlock" />
</template>
